<div class="is-flex is-column is-justify-space-between is-fullheight">

  <div class="is-flex is-column gap-24 is-align-center text-align-center">
    <app-text class="text-22 is-family-semiBold">{{ 'common-app.__UNPLACED_PRODUCT_WEBAPP_TITLE' | AsyncLang | async }}</app-text>
    <app-text>{{ 'common-app.__UNPLACED_PRODUCT_WEBAPP_DESCRIPTION' | AsyncLang | async }}</app-text>
  </div>

  <img src="/assets/images/control-page/assistant/assistant.webp"
    srcset="/assets/images/control-page/assistant/assistant@2x.webp 2x,
      /assets/images/control-page/assistant/assistant@3x.webp 3x">

  <lay-button class="is-flex-button" [routerLink]="['organizing']" [skipLocationChange]="true">
    <button class="is-primary-button">
      <app-text [text]="'legrand-app.__LEG_CONTINUE' | LANG"></app-text>
    </button>
  </lay-button>

</div>